import { DateType, DateValueType } from "react-tailwindcss-datepicker";
import { getDefaultPeriodDate } from "src/utils/date.utils";

export type ChecklistTaskStatus = "IDLE" | "LOADING" | "SUCCESS" | "FAILURE";

export type ChecklistTaskFilters = {
  email: string;
  jobTitle: string;
  periodDate: DateValueType;
  currentUserEmail: string;
};

export type TaskResult = {
  isDone: boolean;
  hasDeviation: boolean;
};

export type TaskItem = {
  ID: number;
  Status?: string;
  ResponsibleEmail: string;
  AuthorEmail: string;
  Test: string | any[];
  PassTest: string;
  CheckListID: number | string;
  ConnectionID: number | string;
  Direction: string;
  Period: string;
  Task: {
    Title: string;
    Description: string;
    CompletionCriteria: string;
  };
  EndDate: Date | null;
  Answers: any[];
  Result: TaskResult;
  countActions: number;
  disabled: boolean;
  isDeleted: boolean;
};

export type ChecklistShiftFilters = {
  email: string;
  date?: DateType;
};

export type CompleteChecklistShiftPayload = ChecklistShiftFilters & {
  comment?: string;
};

export type ReturnChecklistShiftPayload = {
  ID: number;
};

export type ShiftItem = {
  ID: number;
  ResponsibleEmail: string;
  Date: string;
  Comment: string;
  Finished: boolean;
};

export type ChecklistTasksState = {
  entities: Record<number, TaskItem>;
  ids: number[];
  shiftItems: ShiftItem[];
  selectedId: number | null;
  status: ChecklistTaskStatus;
  shiftStatus: ChecklistTaskStatus;
  shiftMutationStatus: ChecklistTaskStatus;
  selectedStatus: ChecklistTaskStatus;
  error: string | null;
  shiftError: string | null;
  filters: ChecklistTaskFilters | null;
  shiftFilters: ChecklistShiftFilters | null;
  periodDate: DateValueType;
};

export const initialChecklistTasksState: ChecklistTasksState = {
  entities: {},
  ids: [],
  shiftItems: [],
  selectedId: null,
  status: "IDLE",
  shiftStatus: "IDLE",
  shiftMutationStatus: "IDLE",
  selectedStatus: "IDLE",
  error: null,
  shiftError: null,
  filters: null,
  shiftFilters: null,
  periodDate: getDefaultPeriodDate(),
};
